import React, { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { CContainer, CSpinner } from '@coreui/react-pro'

// routes config
import routes from '../routes'

const AppContent = () => {
  return (
    // <CContainer>
    <Suspense fallback={<CSpinner color="primary" />}>
      <Routes>
        {routes.map((route, idx) => {
          return (
            route.element && (
              <Route
                key={idx}
                path={route.path}
                exact={route.exact}
                name={route.name}
                element={<route.element />}
              />
            )
          )
        })}
        <Route path="/" element={<Navigate to="dashboard" replace />} />
        {/* Sponsors and promo cards were merged into one tabbed page; keep old links working. */}
        <Route path="/promo-cards" element={<Navigate to="/sponsor-directory" replace />} />
      </Routes>
    </Suspense>
    // </CContainer>
  )
}

export default React.memo(AppContent)
